import React from 'react'
import styled from 'styled-components'
import ScrollToTop from 'react-scroll-up'

const Button = styled.div`
  z-index: 9000;
  margin: auto;
  padding: 10px 20px;
  width: 250px;
  height: 40px;
  font-size: 16px;
  letter-spacing: 6px;
  text-align: center;
  text-transform: uppercase;
  border: 1px solid #ffffff;
  border-bottom: 0;
  cursor: pointer;
  transition: height 0.5s;
  background: black;

  :hover {
    height: 60px;
  }
`

export default ({ title }) => (
  <ScrollToTop
    style={{
      position: "fixed",
      right: 0,
      bottom: 0,
      left: 0,
      transitionDuration: '0.3s',
      transitionTimingFunction: 'linear',
      transitionDelay: '0s',
      cursor: 'pointer',
      overflow: "hidden",
    }}
    showUnder={10000}
  >
    <Button>{title}</Button>
  </ScrollToTop>
)



// WEBPACK FOOTER //
// ./src/components/scroll-up.js